import { ParametersExtractor } from '../parameters-extractor/parameters-extractor';

export class IsProgrammaticRetriever {
  constructor(
    private parametersExtractor: ParametersExtractor,
    private aWindow: Window
  ) {}

  public getIsProgrammatic(): boolean {
    let isProgrammatic: boolean | undefined;
    let executionEnvironment: string | undefined;
    try {
      isProgrammatic = this.parametersExtractor.getContextParameters<boolean>(
        'is_programmatic',
        this.aWindow,
        'parameters'
      );
      executionEnvironment = this.parametersExtractor.getContextParameters<
        string
      >('executionEnvironment', this.aWindow);
    } catch (error) {
      isProgrammatic = undefined;
      executionEnvironment = undefined;
    }
    if (isProgrammatic === true) {
      return true;
    }

    if (executionEnvironment !== undefined && executionEnvironment !== '') {
      return executionEnvironment !== 'ogury';
    }

    return Boolean(isProgrammatic);
  }
}
